import task from '@nextories/vue-tasks/src/i18n/langs/fr/task';

export default {
  ...task,
  select: {
    ...task.select,
    status: [
      {
        name: 'À traiter',
        value: 'Not Started',
        disabled: true,
      },
      {
        name: 'En attente',
        value: 'Pending Input',
      },
      {
        name: 'En cours',
        value: 'In Progress',
      },
      {
        name: 'Terminé',
        value: 'Completed',
      },
      {
        name: 'Décalé',
        value: 'Deferred',
        disabled: true,
      },
    ],
  },
};
